import {
  CourseCreateInterface,
  CourseEditApiInterface,
  CourseEditInterface,
  CourseId,
  CourseInterface,
} from 'modules/courses/courses/types/course-interface'
import {
  ReminderEditInterface,
  ReminderEmailInterface,
  ReminderInterface,
} from 'modules/courses/courses/types/reminder-interface'
import { StudentInterface } from 'modules/courses/students/types/student-interface'
import httpClient from 'shared/utils/http-client'
import { ModuleId, ModuleInterface } from '../types/module-interface'
import { CreateStudentApiInterface } from '../types/student-interface'

export const COURSE_API = '/api/dashboard/customer/membership/course'
export const COURSES_API = '/api/dashboard/customer/membership/courses'
export const COURSE_MODULE_API = '/api/dashboard/customer/membership/module'

export const LECTURE_API = '/api/dashboard/customer/membership/lecture'

export const getModulesListAllPath = (courseId: CourseId) =>
  `${COURSES_API}/${courseId}/modules/list-all`

export const duplicateCourse = (id: CourseId) =>
  httpClient.post<CourseInterface>(`${COURSES_API}/${id}/duplicate`)

export const removeCourse = (id: CourseId) => httpClient.delete(`${COURSES_API}/${id}`)

export const activateCourse = (update: 'deactivate' | 'activate', id: CourseId) =>
  httpClient.post<CourseInterface>(`${COURSES_API}/${id}/${update}`)

export const updateCourse = (data: CourseEditInterface, id: CourseId) =>
  httpClient.put<CourseEditApiInterface>(`${COURSES_API}/${id}`, data)

export const createCourse = (data: Partial<CourseCreateInterface>) =>
  httpClient.post<CourseCreateInterface, CourseInterface>(COURSES_API, data)

export const enableReminder = (id: CourseId) =>
  httpClient.post(`${COURSES_API}/${id}/reminder-settings/enable`)

export const disableReminder = (id: CourseId) =>
  httpClient.post(`${COURSES_API}/${id}/reminder-settings/disable`)

export const editReminderSettings = (id: CourseId, data: ReminderEditInterface) =>
  httpClient.put<ReminderInterface>(`${COURSES_API}/${id}/reminder-settings`, data)

export const createReminderEmail = (id: CourseId, data: ReminderEmailInterface) =>
  httpClient.post<ReminderEmailInterface>(`${COURSES_API}/${id}/reminder-settings/email`, data)

export const editReminderEmail = (id: CourseId, data: ReminderEmailInterface) =>
  httpClient.put<ReminderEmailInterface>(`${COURSES_API}/${id}/reminder-settings/email`, data)

export const duplicateModule = <T = ModuleInterface>(
  id: ModuleId,
  data: { salesFunnelStep: number | null },
) => httpClient.post<T>(`/api/membership/secure/label/modules/${id}/duplicate`, data)

export const addStudent = (id: CourseId, data: CreateStudentApiInterface) =>
  httpClient.post<StudentInterface>(`${COURSE_API}/${id}/enrollment`, data)
